import { useTranslation } from "react-i18next";

import i1 from '../../img/About/i1.png'
import i2 from '../../img/About/i2.png'
import i3 from '../../img/About/i3.png'
import i4 from '../../img/About/i4.png'
import i5 from '../../img/About/i5.png'
import i6 from '../../img/About/i6.png'

function OurAch () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative mt-[100px] xl:mt-[140px]">
            <div className="max-w-[1220px] mx-[20px] xl:mx-auto flex flex-col items-center">
                <p className="manrope text-[24px] text-center mx-auto xl:text-[36px] font-[500] xl:max-w-[570px] leading-[1.2] text-[#000000]">{t('about.32')}</p>
                <div className="grid grid-cols-3 xl:grid-cols-6 gap-x-[40px] xl:gap-x-[60px] gap-y-[20px] mt-[40px] xl:mt-[60px]">
                    <div className="w-[86px] h-[86px] xl:w-[116px] xl:h-[116px] flex items-center justify-center">
                        <img src={i1} className="object-contain w-full h-full" alt="" />
                    </div>
                    <div className="w-[86px] h-[86px] xl:w-[116px] xl:h-[116px] flex items-center justify-center">
                        <img src={i2} className="object-contain w-full h-full" alt="" />
                    </div>
                    <div className="w-[86px] h-[86px] xl:w-[116px] xl:h-[116px] flex items-center justify-center">
                        <img src={i3} className="object-contain w-full h-full" alt="" />
                    </div>
                    <div className="w-[86px] h-[86px] xl:w-[116px] xl:h-[116px] flex items-center justify-center">
                        <img src={i4} className="object-contain w-full h-full" alt="" />
                    </div>
                    <div className="w-[86px] h-[86px] xl:w-[116px] xl:h-[116px] flex items-center justify-center">
                        <img src={i5} className="object-contain w-full h-full" alt="" />
                    </div>
                    <div className="w-[86px] h-[86px] xl:w-[116px] xl:h-[116px] flex items-center justify-center">
                        <img src={i6} className="object-contain w-full h-full" alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurAch;  